import { SERVICE_CONTACT } from '@/libs/constant';
import { html } from 'rune-ts';
import klass from '../../../Terms.module.scss';

export const version_20200113 = html`
  <div class="${klass.terms_container}">
    <div class="${klass.toc}">
      <ul>
        <li><a href="#privacy1">1. 셀러스튜디오 개인정보 처리방침이란 </a></li>
        <li><a href="#privacy2">2. 개인정보 수집 </a></li>
        <li><a href="#privacy3">3. 개인정보 이용 </a></li>
        <li><a href="#privacy4">4. 개인정보 제공 </a></li>
        <li><a href="#privacy5">5. 개인정보 파기 </a></li>
        <li><a href="#privacy6">6. 이용자 및 법정대리인의 권리와 행사 방법 </a></li>
        <li><a href="#privacy7">7. 기타사항 </a></li>
        <li><a href="#privacy8">8. 고지의 의무 </a></li>
      </ul>
    </div>
    <div class="${klass.body} ${klass.no_list_style}">
      <div>
        <h3 id="privacy1">1. 셀러스튜디오 개인정보 처리방침이란</h3>
        <p>
          (주)마플코퍼레이션(이하”회사”)은 이용자의 ‘동의를 기반으로 개인정보를 수집·이용 및 제공’하고 있으며, ‘이용자의
          권리 (개인정보 자기결정권)를 적극적으로 보장’합니다. 회사는 정보통신서비스제공자가 준수하여야 하는 대한민국의
          관계 법령 및 개인정보보호 규정, 가이드라인을 준수하고 있습니다. “개인정보처리방침”이란 이용자의 소중한
          개인정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 회사가 준수해야 할 지침을 의미합니다. 본
          개인정보 처리방침은 개인 또는 사업자의 서비스를 위해 회사가 제공하는 서비스에 적용됩니다.
        </p>
      </div>
      <div>
        <h3 id="privacy2">2. 개인정보 수집</h3>
        <p>
          A. 회사는 비지니스 기능별 필요 최소한의 개인정보 및 서비스이용 내역 등의 개인정보를 다음과 같이 수집하고
          있습니다.
        </p>
        <p>
          <strong>&lt;개인정보 항목&gt;</strong>
        </p>
        <div>
          <div>- 판매자 회원계정</div>
          <ul>
            <li>
              [샵 개설 시 개인정보] 마플샵계정(이메일 또는 전화번호), 이용자 이름(실명), 생년월일, 성별, 이메일,
              전화번호
            </li>
            <li>[사업자로 샵 개설 시] 사업자등록증</li>
            <li>
              [법정대리인 동의 시 / 필수] 법정대리인 정보(이름, 성별, 생년월일, 휴대폰번호, 통신사업자, 내·외국인 여부,
              암호화된 이용자 확인값(CI), 중복가입확인정보(DI)
            </li>
          </ul>
        </div>
        <p>
          B. 정산대금 지급, 계좌인증 및 원천징수 처리를 위해 「소득세법」제 145조, 제164조에 따라 아래와 같은 개인정보를
          수집하고 있습니다.
        </p>
        <div>
          <div>- 정산대금 및 계좌인증</div>
          <ul>
            <li>[필수] 예금주명, 계좌번호, 은행명</li>
            <li>[선택] 계좌사본, 신분증 사본(마스킹)</li>
          </ul>
        </div>
        <div>
          <div>- 원천징수처리, 지급명세서 제출, 개인사업자 사업소득 신고, 휴·폐업자 소득신고 및 처리결과 회신</div>
          <ul>
            <li>[필수] 이름, 주민등록번호, 주소, 이메일</li>
          </ul>
        </div>
        <p>C. 유료 서비스 이용 과정에서 아래와 같은 결제 정보들이 수집될 수 있습니다.</p>
        <div>
          <div>- 신용카드결제 시: 카드사명, 카드번호(일부) 등</div>
          <div>- 휴대전화결제 시: 휴대전화번호, 결제승인번호 등</div>
          <div>- 계좌이체 시: 예금주명, 계좌번호, 은행명</div>
        </div>
        <p>D. 서비스 이용과정에서 이용자로부터 수집하는 개인정보는 아래와 같습니다.</p>
        <p>
          PC웹, 모바일 웹/앱 이용 과정에서 단말기정보(OS, 화면사이즈, 디바이스 아이디, 폰기종, 단말기 모델명), IP주소,
          쿠키, 방문일시, 부정이용기록, 서비스 이용 기록 등의 정보가 자동으로 생성되어 수집될 수 있습니다.
        </p>
        <p>E. 개인정보 수집방법</p>
        <div>
          <div>회사는 아래와 같은 방법으로 개인정보를 수집합니다.</div>
          <ul>
            <li>회원가입 및 서비스 이용과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우</li>
            <li>제휴 서비스 또는 단체 등으로부터 개인정보를 제공받는 경우</li>
            <li>고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등</li>
            <li>온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
          </ul>
        </div>
      </div>
      <div>
        <h3 id="privacy3">3. 개인정보 이용</h3>
        <p>
          회원관리, 서비스 제공·개선, 신규 서비스 개발 등을 위해 이용합니다. 회원 가입 시 또는 서비스 이용 과정에서
          홈페이지 또는 개별 어플리케이션이나 프로그램 등을 통해 아래와 같이 서비스 제공을 위해 필요한 최소한의
          개인정보를 수집하고 있습니다.
        </p>
        <div>
          <ul>
            <li>회원 식별/가입의사 확인, 본인/연령 확인, 부정이용 방지</li>
            <li>14세 미만 아동 개인정보 수집 시 법정대리인 동의여부 확인, 법정대리인 권리행사 시 본인 확인</li>
            <li>신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리, 공지사항 전달</li>
            <li>유료서비스 이용 시 컨텐츠 등의 전송이나 배송·요금 정산</li>
            <li>서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등 포함)에 대한 방지 및 제재</li>
            <li>
              서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호 측면의 서비스 환경 구축, 서비스
              개선에 활용
            </li>
          </ul>
        </div>
      </div>
      <div>
        <h3 id="privacy4">4. 개인정보 제공</h3>
        <p>
          회사는 이용자들의 개인정보를 “03. 개인정보 이용”에 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동
          범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는
          예외로 합니다.
        </p>
        <div>
          <ul>
            <li>이용자들이 사전 제공에 동의한 경우</li>
            <li>법령의 규정에 의거하거나, 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
          </ul>
        </div>
      </div>
      <div>
        <h3 id="privacy5">5. 개인정보 파기</h3>
        <p>
          전자적 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제하고, 그 밖에 기록물, 인쇄물, 서면 등의 경우
          분쇄하거나 소각하여 파기합니다.
        </p>
        <p>다만, 내부 방침에 따라 일정 기간 보관 후 파기하는 정보는 아래와 같습니다.</p>
        <div>
          <div>- 회사 내부 방침에 의한 정보보유 사유</div>
          <table>
            <thead>
              <tr>
                <th>보관 정보</th>
                <th>보존 이유</th>
                <th>보존 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>부정 이용 기록</td>
                <td>부정 이용 방지</td>
                <td>1년</td>
              </tr>
              <tr>
                <td>회원 탈퇴 기록</td>
                <td>고객 문의 응대</td>
                <td>탈퇴일로부터 30일</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          또한, 회사는 ‘개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관 또는
          삭제하고 있으며, 분리 보관된 개인정보는 4년간 보관 후 지체없이 파기합니다.
        </p>
        <p>이 외에 법령에 따라 일정기간 보관해야 하는 개인정보 및 해당 법령은 아래 표와 같습니다.</p>
        <div>
          <table>
            <thead>
              <tr>
                <th>보관 정보</th>
                <th>보존 이유</th>
                <th>보존 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>계약 또는 쳥약철회 등에 관한 기록</td>
                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                <td>3년</td>
              </tr>
              <tr>
                <td>표시/광고에 관한 기록</td>
                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                <td>6개월</td>
              </tr>
              <tr>
                <td>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</td>
                <td>국세기본법, 법인세법</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>전자금융 거래에 관한 기록</td>
                <td>전자금융거래법</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>웹사이트 방문에 관한 기록</td>
                <td>통신비밀보호법</td>
                <td>3개월</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <h3 id="privacy6">6. 이용자 및 법정대리인의 권리와 행사방법</h3>
        <p>
          이용자는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 수집・이용에 대한 동의 철회 또는 가입 해지를
          요청할 수 있습니다.
        </p>
        <p>
          보다 구체적으로는 서비스 내 설정을 통한 회원정보 수정 기능이나 회원탈퇴 기능을 이용할 수 있고, 고객센터를 통해
          서면, 전화 또는 이메일로 요청하시면 지체 없이 조치하겠습니다.
        </p>
        <p>
          개인정보의 오류에 대한 정정을 요청하신 경우 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지
          않습니다.
        </p>
        <p>또한, 만 14세 미만 이용자의 법정대리인은 위의 모든 권리를 요청할 수 있습니다.</p>
      </div>
      <div>
        <h3 id="privacy7">7. 기타사항</h3>
        <p>웹기반 서비스의 제공을 위하여 쿠키를 이용하는 경우가 있습니다.</p>
        <p>쿠키는 보다 빠르고 편리한 웹사이트 사용을 지원하고 맞춤형 서비스를 제공하기 위해 사용됩니다.</p>
        <strong>쿠키란? </strong>
        <p>
          쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의
          컴퓨터에 저장됩니다.
        </p>
        <strong>사용목적</strong>
        <p>
          회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 쿠키를
          사용합니다. 이용자가 웹사이트에 방문할 경우 웹 사이트 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을
          읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하게 됩니다. 쿠키는 이용자가 웹 사이트를 방문할 때, 웹
          사이트 사용을 설정한대로 접속하고 편리하게 사용할 수 있도록 돕습니다. 또한, 이용자의 웹사이트 방문 기록, 이용
          형태를 통해서 최적화된 광고 등 맞춤형 정보를 제공하기 위해 활용됩니다.
        </p>
        <strong>쿠키수집거부</strong>
        <p>
          쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는 쿠키 설치에 대한 선택권을 가지고
          있습니다. 따라서, 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다
          확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 다만 쿠키 설치를 거부할 경우 웹 사용이 불편해지며
          로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
        </p>
        <div>
          <div>&lt;설정 방법의 예&gt;</div>
          <ul>
            <li>Internet Explorer의 경우 : 웹 브라우저 상단의 도구 메뉴 &gt; 인터넷 옵션 &gt; 개인정보 &gt; 설정</li>
            <li>
              Chrome의 경우 : 웹 브라우저 우측의 설정 메뉴 &gt; 화면 하단의 고급 설정 표시 &gt; 개인정보의 콘텐츠 설정
              버튼 &gt; 쿠키
            </li>
          </ul>
        </div>
        <strong>개인정보보호와 관련해서 궁금하신 사항은? </strong>
        <p>
          서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타 사항은 개인정보 보호책임자 및
          담당부서로 연락해 주시기 바랍니다. 마플샵은 여러분의 목소리에 귀 기울이고 신속하고 충분한 답변을 드릴 수
          있도록 최선을 다하겠습니다.
        </p>
        <p>문의:개인정보보호관련 문의/ ${SERVICE_CONTACT.MarppleShop.tel}</p>
        <p>
          또한, 개인정보가 침해되어 이에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하셔서 도움을 받으실 수
          있습니다.
        </p>
        <p>
          개인정보침해신고센터 (<a href="https://privacy.kisa.or.kr">https://privacy.kisa.or.kr</a> / 국번없이 118 )
        </p>
        <p>대검찰청 사이버수사과 ( cid@spo.go.kr / 국번없이 1301 )</p>
        <p>
          경찰청 사이버안전국 (
          <a href="https://cyberbureau.police.go.kr">https://cyberbureau.police.go.kr</a> / 국번없이 182 )
        </p>
      </div>
      <div>
        <h3 id="privacy8">8. 고지의 의무</h3>
        <p>
          개인정보 처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 ‘공지사항’을 통해
          고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는
          최소 30일 전에 고지합니다.
        </p>
        <div>
          <ul>
            <li>공고일자: 2020년 1월 13일</li>
            <li>시행일자: 2020년 1월 13일</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
`;
